<template>
  <div class='notice atb-flex atb-flex-column'>
    <div class='tab'>
      <Tabs :tab-list="tabList" :defaultIndex="defaultTab" @getCurrent="getCurrent" />
    </div>
    <div v-show="currentTab == 0" class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search-wrap'>
        <el-form :inline="true" :model="declareForm" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
            <!-- <el-form-item class="form-param-item" label="上级">
              <selecter v-model="declareForm.SuperiorNo" clearable></selecter>
            </el-form-item> -->
            <el-form-item class="form-param-item" label="姓名">
              <selecter v-model="declareForm.WkName" clearable @selecterData="getSelecterData"></selecter>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
            <el-form-item v-if="!this.wkNo && !this.msgId && $auth(that, 'Commit')">
              <el-button type="export" @click="commitTip">提交</el-button>
            </el-form-item>
            <el-form-item v-if="!this.wkNo && !this.msgId">
              <el-button type="refuse" @click="showRevert = true">撤回</el-button>
            </el-form-item>
            <el-form-item v-if="!this.wkNo && !this.msgId">
              <el-button type="downloadTemplate" @click="showApproveReason = true">审批意见</el-button>
            </el-form-item>
            <!-- <el-popover
              placement="right"
              width="250"
              trigger="hover"
              :content="approveReasonText">
              <el-form-item v-if="!this.wkNo && !this.msgId" slot="reference">
                <el-button type="downloadTemplate">审批意见</el-button>
              </el-form-item>
            </el-popover> -->
            
            <el-form-item v-if="this.wkNo && this.msgId">
              <el-button :disabled="this.role == 2" type="primary" @click="showAccess = true">通过</el-button>
            </el-form-item>
            <el-form-item v-if="this.wkNo && this.msgId">
              <el-button :disabled="this.role == 2" type="refuse" @click="showRefuse = true">驳回</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="exportResultExcel">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button plain type="downloadTemplate" @click="declareExpandRowAll">{{declareExpandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
            </el-form-item>
        </el-form>
      </div>
      <div class="summary">
         <span class="item-data">本月参评人数:<span class="num">{{currentSum.totalCount||0}}</span></span>
           <span class="item-data">本月应得A人数:<span class="num">{{currentSum.regulationACurrentAll||0}}</span></span>
             <span class="item-data">本月应得C人数:<span class="num">{{currentSum.regulationCCurrentAll||0}}</span></span>
               <span class="item-data">实际本月得A人数:<span :class="currentSum.realityACurrentAll>currentSum.regulationACurrentAll? warnNum: nomalNum">{{currentSum.realityACurrentAll||0}}</span></span>
                 <span class="item-data">实际本月得C人数:<span :class="currentSum.realityCCurrentAll<currentSum.regulationCCurrentAll? warnNum: nomalNum">{{currentSum.realityCCurrentAll||0}}</span></span>
      </div>
      <div class="summary">
         <span class="item-data">累计参评人数:<span class="num">{{rateSum.totalCount||0}}</span></span>
           <span class="item-data">累计应得A人数:<span class="num">{{rateSum.regulationACurrentAll||0}}</span></span>
             <span class="item-data">累计应得C人数:<span class="num">{{rateSum.regulationCCurrentAll||0}}</span></span>
               <span class="item-data">实际累计得A人数:<span :class="rateSum.realityACurrentAll>rateSum.regulationACurrentAll? warnNum: nomalNum">{{rateSum.realityACurrentAll||0}}</span></span>
                 <span class="item-data">实际累计得C人数:<span :class="rateSum.realityCCurrentAll<rateSum.regulationCCurrentAll? warnNum: nomalNum">{{rateSum.realityCCurrentAll||0}}</span></span>
                  <span class="item-data" style="color:#fe6562">（注意：评级结果为A或C时必须填写评级原因！）</span>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="unHandle"
          :edit-rules="validRules"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @cell-click="expandRow"
          :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true}"
        >
          <vxe-table-column type="seq" min-width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="wk" width="185" title="姓名">
             <template #default="{ row }">
              <span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" width="185" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="date" title="年/月" width="80">
            <template #default="{row}">{{row.year+'/'+row.month}}</template>
          </vxe-table-column>
          <!-- <vxe-table-column field="declareDate" title="时间" width="100">
            <template #default="{row}">
              <span>{{row.creationTime ? XEUtils.toDateString(new Date(row.creationTime), 'yyyy-MM-dd') : ''}}</span>
            </template>
          </vxe-table-column> -->
          <vxe-table-column width="90" field="ratingResult" title="OEC评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.ratingResult" @change="$refs.unHandle.updateStatus(scope)">
                <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column width="115" field="isRatingInCurrentMonth" title="当月是否参评">
            <template #default="{row}">
              <span>{{row.isRatingInCurrentMonth ? "是" : '否'}}</span>
            </template>
          </vxe-table-column>
          <!--          <vxe-table-column field="creatorName" title="创建人" width="100"></vxe-table-column>-->
          <!--          <vxe-table-column field="lastModifierName" title="最后修改人" width="120"></vxe-table-column>-->
          <vxe-table-column min-width="160" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.ratingReason"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.ratingReason}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="300" field="recommendList" title="评级建议">
            <template #default="{row}">
              <pre :class="[row.expandRowFlag ? '' : 'atb-ellipsis-line-2', 'flex', 'atb-flex-items-center', 'pre-line']" v-html="formatRecommendList(row.recommendList)"></pre>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remarks"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remarks}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="95" fixed="right">
            <template #default="{ row,column }">
              <el-tag :type="row.status == 0 ? 'unstart' : (row.status == 1 ? 'complete' : 'ongoing') " effect="dark">
                {{ OecStatusList.length>0 && OecStatusList.find(t=>t.itemValue==row[column.property])? OecStatusList.find(t=>t.itemValue==row[column.property]).itemDesc: '' }}
              </el-tag>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="page.PageIndex"
          :page-size.sync="page.PageSize"
          :total="total"
          height="100%"
          @page-change="pageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <div v-show="currentTab == 1" class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search-wrap'>
        <el-form :inline="true" :model="authForm" class="atb-input" @keyup.enter.native.prevent="getList()" @submit.native.prevent>
            <el-form-item class="form-param-item" label="上级">
              <selecter v-model="authForm.SuperiorNo" clearable></selecter>
            </el-form-item>
            <el-form-item class="form-param-item" label="姓名">
              <selecter v-model="authForm.WkNo" clearable></selecter>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList()">查询</el-button>
            </el-form-item>
            <el-form-item v-if="$auth(that, 'Commit')">
              <el-button type="export" @click="commitTip">提交</el-button>
            </el-form-item>
        </el-form>
      </div>
      <div class="summary">
         <span class="item-data">累计参评人数:<span class="num">{{summary.totalCount||0}}</span></span>
           <span class="item-data">累计应得A人数:<span class="num">{{summary.regulationACurrentAll||0}}</span></span>
             <span class="item-data">累计应得C人数:<span class="num">{{summary.regulationCCurrentAll||0}}</span></span>
               <span class="item-data">实际累计得A人数:<span :class="summary.realityACurrentAll>summary.regulationACurrentAll? warnNum: nomalNum">{{summary.realityACurrentAll||0}}</span></span>
                 <span class="item-data">实际累计得C人数:<span :class="summary.realityCCurrentAll<summary.regulationCCurrentAll? warnNum: nomalNum">{{summary.realityCCurrentAll||0}}</span></span>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="queryDeclareResult"
          :edit-rules="validRules"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @cell-click="expandRow"
          :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasChild', loadMethod: loadChildren}"
        >
          <vxe-table-column type="seq" min-width="100" title="NO."></vxe-table-column>
          <vxe-table-column field="wk" min-width="300" title="姓名" tree-node>
             <template #default="{ row }">
              <span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="160" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="date" title="年/月" width="80">
            <template #default="{row}">{{row.year+'/'+row.month}}</template>
          </vxe-table-column>
          <vxe-table-column field="declareDate" title="时间" width="100">
            <template #default="{row}">
              <span>{{row.creationTime ? XEUtils.toDateString(new Date(row.creationTime), 'yyyy-MM-dd') : ''}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="90" field="ratingResult" title="OEC评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.ratingResult" @change="$refs.queryDeclareResult.updateStatus(scope)">
                <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column width="115" field="isRatingInCurrentMonth" title="当月是否参评">
            <template #default="{row}">
              <span>{{row.isRatingInCurrentMonth ? "是" : '否'}}</span>
            </template>
          </vxe-table-column>
          <!--          <vxe-table-column field="creatorName" title="创建人" width="100"></vxe-table-column>-->
          <!--          <vxe-table-column field="lastModifierName" title="最后修改人" width="120"></vxe-table-column>-->
          <vxe-table-column min-width="180" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.ratingReason"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.ratingReason}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="160" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remarks"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remarks}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="95" fixed="right">
            <template #default="{ row,column }">
              <el-tag type="complete" effect="dark">
                {{ OecStatusList.length>0 && OecStatusList.find(t=>t.itemValue==row[column.property])? OecStatusList.find(t=>t.itemValue==row[column.property]).itemDesc: '' }}
              </el-tag>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <div v-if="currentTab == 2" class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="form" class="atb-input" @keyup.enter.native.prevent="getHistoryList(1)" @submit.native.prevent>
          <div class="query-where">
            <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
              <el-popover
                placement="bottom-start"
                width="420"
                popper-class="popper-tree declare-dep"
                @hide="historyHandledHide"
                trigger="click">
                <el-tree
                  :props="defaultProps"
                  :data="historyTreeData"
                  show-checkbox
                  node-key='id'
                  ref="historyTree"
                  highlight-current
                  check-strictly
                  :default-expanded-keys="expandedData"
                  :filter-node-method="filterHistoryDeptNode"
                  @check-change="historyHandleCheckChange">
                </el-tree>
                <el-input slot="reference" v-model="historyDepartment" placeholder="请选择部门名称" clearable></el-input>
              </el-popover>
            </el-form-item>
            <el-form-item class="flex-form-item" label="上级">
              <selecter v-model="form.SuperiorNo" clearable></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="姓名">
              <selecter v-model="form.WkNo" clearable></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="月份">
              <el-date-picker
                v-model="form.month"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="query-operation">
            <el-form-item class="flex-form-item" label="OEC评定结果">
              <el-select clearable v-model="form.OecResult" placeholder="OEC评定结果">
                <el-option v-for="item in oecLevel" :key="item.value" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="状态">
              <common-select ref="status" v-model="form.Status" :list="OecStatusList" optLabel="itemDesc" optValue="itemValue" placeholder="状态" clearable></common-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getHistoryList(1)">查询</el-button>
            </el-form-item>
            <el-form-item v-if="$auth(that, 'HistoryExport','OEC.ManageConsole')">
              <el-button type="export" @click="exportExcel">导出</el-button>
            </el-form-item>
            <el-form-item v-if="$auth(that, 'HistoryExport','OEC.ManageConsole')">
              <el-button type="downloadTemplate" @click="exportMulti">批量导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button plain type="downloadTemplate" @click="historyExpandRowAll">{{historyExpandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="summary">
         <span class="item-data">本月参评人数:<span class="num">{{currentSummary.totalCount||0}}</span></span>
           <span class="item-data">本月应得A人数:<span class="num">{{currentSummary.regulationACurrentAll||0}}</span></span>
             <span class="item-data">本月应得C人数:<span class="num">{{currentSummary.regulationCCurrentAll||0}}</span></span>
               <span class="item-data">实际本月得A人数:<span :class="currentSummary.realityACurrentAll>currentSummary.regulationACurrentAll? warnNum: nomalNum">{{currentSummary.realityACurrentAll||0}}</span></span>
                 <span class="item-data">实际本月得C人数:<span :class="currentSummary.realityCCurrentAll<currentSummary.regulationCCurrentAll? warnNum: nomalNum">{{currentSummary.realityCCurrentAll||0}}</span></span>
      </div>
      <div class="summary">
         <span class="item-data">累计参评人数:<span class="num">{{summary.totalCount||0}}</span></span>
           <span class="item-data">累计应得A人数:<span class="num">{{summary.regulationACurrentAll||0}}</span></span>
             <span class="item-data">累计应得C人数:<span class="num">{{summary.regulationCCurrentAll||0}}</span></span>
               <span class="item-data">实际累计得A人数:<span @click="showHisOec" class="cursor" :class="summary.realityACurrentAll>summary.regulationACurrentAll? warnNum: nomalNum">{{summary.realityACurrentAll||0}}</span></span>
                 <span class="item-data">实际累计得C人数:<span @click="showHisOec" class="cursor" :class="summary.realityCCurrentAll<summary.regulationCCurrentAll? warnNum: nomalNum">{{summary.realityCCurrentAll||0}}</span></span>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table'
          border='inner'
          height='100%'
          ref="handled"
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="historyData"
          @cell-click="historyExpandRow"
          :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasChild', loadMethod: loadChildren}"
        >
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="wkName" title="姓名" min-width="200" tree-node>
            <template #default="{ row }">
              <span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="wkNo" title="上级" width="150">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220">
            <template #default="{row}">{{row.department}}</template>
          </vxe-table-column>
          <vxe-table-column field="date" title="年/月" width="80">
            <template #default="{row}">{{row.year+'/'+row.month}}</template>
          </vxe-table-column>
          <!-- <vxe-table-column field="declareDate" title="时间" width="100">
            <template #default="{row}">
              <span>{{row.o.creationTime ? XEUtils.toDateString(new Date(row.o.creationTime), 'yyyy-MM-dd') : ''}}</span>
            </template>
          </vxe-table-column> -->
          <vxe-table-column field="ratingResult" title="评定结果" width="100">
             <template #default="{row}">{{row.ratingResult}}</template>
          </vxe-table-column>
          <!-- <vxe-table-column field="jobDate" title="入职日期" width="100">
            <template #default="{row}">
              <span>{{row.jobDate ? XEUtils.toDateString(new Date(row.jobDate), 'yyyy-MM-dd') : ''}}</span>
            </template>
          </vxe-table-column> -->
          <vxe-table-column width="115" field="isRatingInCurrentMonth" title="当月是否参评">
            <template #default="{row}">
              <span>{{row.isRatingInCurrentMonth ? "是" : '否'}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="ratingReason" title="评定原因" min-width="200">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.ratingReason}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="300" field="recommendList" title="评级建议">
            <template #default="{row}">
              <pre :class="[row.expandRowFlag ? '' : 'atb-ellipsis-line-2', 'flex', 'atb-flex-items-center', 'pre-line']" v-html="formatRecommendList(row.recommendList)"></pre>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" title="备注" min-width="150">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remarks}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="120">
            <template #default="{ row,column }">
              <el-tag type="complete" effect="dark">
                {{ OecStatusList.length>0 && OecStatusList.find(t=>t.itemValue==row[column.property])? OecStatusList.find(t=>t.itemValue==row[column.property]).itemDesc: '' }}
              </el-tag>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <!-- <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="historyPage.PageIndex"
          :page-size.sync="historyPage.PageSize"
          :total="historyTotal"
          height="100%"
          @page-change="historyPageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div> -->
    </div>
    <div v-if="currentTab == 3" class='atb-content-bg atb-flex atb-flex-column'>
      <DeclareResultAmendment />
    </div>
    <el-dialog title="批量处理" :visible.sync="showHandle" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定全部处理吗?</h2>
        <p>处理过之后就不能再修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmHandle">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showCommitTip" width="300px" :close-on-click-modal="false" :close-on-press-escape="false">
      <!-- <div class="content" v-if="needConfirmed">
        <h2>确定要提交吗?</h2>
        <p>提交之后不能修改</p>
        <el-popover
          placement="right-end"
          title="以下人员还未进行填报:"
          width="450"
          trigger="hover"
          popper-class='tipMsg'
          :content="message">
          <p slot="reference" style="color:#fe6562;margin:5px 0px;font-weight:bolder;">{{message.split('、').length>10? message.split('、').splice(0,10).join('、') + '...': message}}</p>
        </el-popover>
       
        <p>如需继续操作点击确认</p>
      </div> -->
      <div class="content">
        <h2>确定要提交吗?</h2>
        <p>提交之后不能修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit()">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showCommitTip = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showAccess"
      width="500px"
      @close="closeAccess"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" placeholder="请填写审批通过原因" v-model="approveReason"> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="approve('access')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showAccess = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showRefuse"
      width="500px"
      @close="closeRefuse"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" placeholder="请填写审批驳回原因" v-model="approveReason"> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="approve('refuse')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showRefuse = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showApproveReason"
      width="500px"
      @close="closeRefuse"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <p style="text-align:left;line-height: 18px;">{{approveReasonText || '无'}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-cancel" type="primary" @click="showApproveReason = false">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="showRevert"
      width="300px"
      @close="closeRefuse"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <h2>确定要撤回当前申报吗?</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="revert()">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showRevert = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="addDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :param="Object.assign(this.form, {departmentNo: this.historyDepartmentNo})"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'
  import _ from 'lodash';

  export default {
    components: {
      selecter: () => import('@/component/global/customerSelect'),
      month:()=>import('./month.vue'),
      history:()=>import('./history-oec.vue'),
      DeclareResultAmendment:()=>import('./DeclareResultAmendment.vue'),
    },
    name: "declare",
    inject: ['reload'],
    data() {
      const ratingReasonValid = ({cellValue, row}) => {
        if (!cellValue) {
          const recommendList = row.recommendList || [];
          let isSame = true;
          for (let i = 0; i < recommendList.length; i++) {
            if (recommendList[i].ratingResult !== row.ratingResult) {
              isSame = false;
              break;
            }
          }
          if (!isSame) {
            return new Error('OEC结果和建议结果存在不同，必须填写原因！')
          }
          if (['A', 'C'].includes(row.ratingResult)) {
            return new Error('评级结果为A、C时必须填写原因！')
          }
        }
      }
      const ratingResultValid = ({cellValue, row}) => {
        const recommendList = row.recommendList || [];
        const hasResultC = recommendList.find(item => item.ratingResult === 'C' && item.importanceLevel == 2);
        if (cellValue === 'A' && hasResultC) {
          return new Error(`OEC建议存在评级强烈建议为C，OEC结果不允许为A`)
        }
      }
      return {
        validRules: {
          ratingResult: [{validator: ratingResultValid}],
          ratingReason: [{validator: ratingReasonValid}],
        },
        XEUtils: XEUtils,
        activeName: 'second',
        currentTab: 0,
        defaultTab: 0,
        showHandle: false,
        handleDelete: true,
        enableHandle: true,
        tabList: [
          {
            label: '结果申报',
            id: 0,
          },
          {
            label: '结果修订',
            id: 3,
          },
          {
            label: '申报查询',
            id: 2,
          },
        ],
        importantList: [
          {label: '否', value: false},
          {label: '是', value: true},
        ],
        oecLevel: [
          {label: 'A'},
          {label: 'B'},
          {label: 'C'},
        ],
        form: {
          month: '',
          WkName: '',
          SuperiorName: '',
          OecResult: '',
        },
        historyPage: {
          PageIndex: 1,
          PageSize: 99999
        },
        historyTotal: 0,
        historyData: [],

        declareForm: {
          isSub: true,
          WkName: ''
        },
        authForm: {},
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        tableData: [],
        summary: {},
        currentSummary: {},
        rateSum: {},
        currentSum: {},
        warnNum: 'warn-num',
        nomalNum: 'num',
        OecStatusList: [],
        that: this,
        depData: [],
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        depList: [],
        checkId: "",
        historyCheckId: "",
        department: '',
        historyDepartment: '',
        copyTreeData: [],
        departmentNo: '',
        historyDepartmentNo: '',
        row: {},
        showCommitTip: false,
        showInteriorCommitTip: false,
        showConfirmTip: false,
        expandedData: [],
        historyTreeData: [],
        historyCopyTreeData: [],
        message: '',
        currWkNo: '',
        authWkNo: '',
        needConfirmed: false,
        editJson: {},
        cacheEditJson: {},
        errMap: 1,
        wkNo: '',
        msgId: '',
        showAccess: false,
        showRefuse: false,
        showRevert: false,
        showApproveReason: false,
        approveReason: '',
        seleterData: {},
        role: 1,
        approveReasonText: '',
        status: '',
        month: '',
        dialogContent: {},
        declareExpandRowAllFlag: false,
        historyExpandRowAllFlag: false,
        importanceList: [],
        recommendStatusList: [],
      }
    },
    created() {
      this.wkNo = this.$route.query.wkNo || '';
      this.msgId = this.$route.query.msgId || '';
      this.role = this.$route.query.role || 1;
      this.date = this.$route.query.date || '';
      this.currentTab = this.$route.query.tab || 0;

      if (this.msgId && this.wkNo) {
        if (this.$route.query.tab == '3') {
          this.tabList = [
            { label: '结果修订', id: 3 },
          ];
        } else {
          this.tabList = [
            {
              label: '结果申报',
              id: 0,
            }
          ];
        }
      }
    },
    mounted() {
      this.defaultTab = this.currentTab;
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';

      this.getRecommendStatus();
      this.getImportanceList();
      this.getList(1);
      this.getOecStatus();
      this.getDep();
      // this.getPersonnelAuthorization(this.currWkNo);
    },
    methods: {
      showHisOec() {
        this.dialogContent = {
          title: '历史数据',
          componentName: 'history',
          width: '1200px'
        }
        this.$refs.addDialog.show();
      },
      getSelecterData(data) {
        this.seleterData = data;
      },
      exportExcel() {
        this.$ajax.get(this.$api.manage.declare.export, {...this.form, departmentNo: this.historyDepartmentNo}, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = 'OEC历史数据'
            const filetype = 'xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },
      exportMulti() {
        this.dialogContent = {
          title: '月份选择',
          componentName: 'month',
          width: '600px'
        }
        this.$refs.addDialog.show();
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      getList(resetPage) {
        if (resetPage) {
          this.page.PageIndex = 1;
        }
        if (this.wkNo) {
          this.currWkNo = this.wkNo;
        }
        let param = {};
        let reqUrl = "";
        const WkNo = this.currentTab === 0 ? this.currWkNo : this.authWkNo;
        const LoginWkNo = this.currentTab === 0 ? this.currWkNo : this.authWkNo;
        this.declareForm.wkNo = this.currWkNo;
        this.declareForm.Date = this.date;
        if (this.currentTab === 0) {
          param = (this.declareForm.WkNo || this.declareForm.SuperiorNo) ? Object.assign({}, this.page, this.declareForm) : Object.assign({}, this.page, this.declareForm);
          reqUrl = (this.declareForm.WkNo || this.declareForm.SuperiorNo) ? this.$api.manage.declare.list : this.$api.manage.declare.list;
        } else if (this.currentTab == 3) {
          return;
        } else {
          param = (this.authForm.WkNo || this.authForm.SuperiorNo) ? Object.assign({}, this.authForm, {LoginWkNo: WkNo}) : Object.assign({}, this.authForm, {WkNo, LoginWkNo});
          reqUrl = (this.authForm.WkNo || this.authForm.SuperiorNo) ? this.$api.manage.declare.list : this.$api.manage.declare.list;
        }
        this.$ajax.get(reqUrl, param).then((res) => {
          this.tableData = res.data.rows && res.data.rows.map(p => {
            p.parentId = null;
            p.hasChild = p.isOrLeader ? true : false;
            return p
          });
          if (this.tableData && this.tableData.length > 0) {
            this.approveReasonText = this.tableData[0].approveReason;
            this.status = this.tableData[0].status;
            this.month = this.tableData[0].year + '-' + this.tableData[0].month;
          }
          this.total = res.data.total;
          if (resetPage) {
            this.getCurrRateSum().then(res => {
              this.rateSum = res;
            });
            this.getCurrRateSum(this.month).then(res => {
              this.currentSum = res;
            });
          }
        });
      },
      loadChildren({row}) {
        return new Promise(resolve => {
          this.$ajax.get(this.$api.manage.declare.history + "?ParentWkNo=" + row.wkNo, {PageIndex: 1, PageSize: 99999, month: this.form.month}).then((res) => {
            if (res.data.rows.length) {
              resolve(res.data.rows && res.data.rows.map(p => {
                p.parentId = row.id;
                p.hasChild = p.isOrLeader ? true : false;
                p.expandRowFlag = this.historyExpandRowAllFlag;
                return p
              }));
            } else {
              row.hasChild = false;
              resolve(row);
            }

          });
        });
      },
      getHistoryList(resetPage) {
        if (resetPage) {
          this.historyPage.PageIndex = 1;
        }
        let param = Object.assign({}, this.historyPage, this.form, {departmentNo: this.historyDepartmentNo});
        this.$ajax.get(this.$api.manage.declare.history, param).then(async(res) => {
          let month;
          this.historyData = res.data.rows && res.data.rows.map(p => {
            p.parentId = null;
            p.hasChild = p.isOrLeader ? true : false;
            return p
          });
          if (this.historyData && this.historyData.length > 0) {
            month = this.tableData[0].year + '-' + this.tableData[0].month;
          }
          // this.historyTotal = res.data.total;
          if (this.form.SuperiorNo) {
            this.getAnalyzeNum({WkNo: this.form.SuperiorNo}).then((res) => {
              this.summary = res;
            });
            this.getAnalyzeNum({WkNo: this.form.SuperiorNo, month: this.form.month || month}).then((res) => {
              this.currentSummary = res;
            });
          }else {
            this.getAnalyzeNum({WkNo: this.currWkNo}).then((res) => {
              this.summary = res;
            });
            this.getAnalyzeNum({WkNo: this.currWkNo, month: this.form.month || month}).then((res) => {
              this.currentSummary = res;
            });
          }
         
        });
      },
      getCurrent(item) {
        this.currentTab = item.data.id;
        if (this.currentTab === 0) {
          this.getList();
        } else if (this.currentTab === 1) {
          this.getList();
        } else if (this.currentTab === 3) {

        } else {
          this.getHistoryList();
        }
      },
      async editClosed({row}) {
        //  $table.clearValidate();
        this.errMap = null;
        this.editJson = JSON.parse(JSON.stringify(row));
        const currVal = {ratingResult: row.ratingResult, ratingReason: row.ratingReason, remarks: row.remarks};
        if (JSON.stringify(this.cacheEditJson) === JSON.stringify(currVal)) {
          this.errMap = 1;
          return;
        }
        const $table = this.currentTab === 0 ? this.$refs.unHandle : this.$refs.queryDeclareResult;
        this.errMap = await $table.validate(row).catch(errMap => errMap)
        if (!this.errMap) {
          this.errMap = 1;
          const {id, ratingResult, ratingReason, remarks, tag, status} = row;
          const loginWkNo = this.currentTab === 0 ? this.currWkNo : this.authWkNo;
          this.$ajax.post(this.$api.manage.declare.create, {id, ratingResult, ratingReason, remarks, tag, status, loginWkNo}).then(async() => {
            this.$message.success("保存成功");
            this.getCurrRateSum().then(res => {
              this.rateSum = res;
            });
            this.getCurrRateSum(this.month).then(res => {
              this.currentSum = res;
            });
          });
        }
      },
      editActived({row}) {
        //InteriorUpdate:内务更新;LeaderUpdate:领导更新;PersonnelUpdate:行政更新;
        // if(row.status === 0){
        //   if(this.$auth(this, 'LeaderUpdate')&&(new Date().getDate()<10||new Date().getDate()>20)){
        //     return true;
        //   }
        // }
        // if(row.status===10){
        //   if(row.tag===1&&this.$auth(this, 'LeaderUpdate')&&(new Date().getDate()<10||new Date().getDate()>20)){
        //     return true;
        //   }
        // }
        if (this.msgId && this.wkNo) {
          return false
        }
        if (row.tag === 1 && this.errMap) {
          const preVal = {ratingResult: row.ratingResult, ratingReason: row.ratingReason, remarks: row.remarks};
          this.cacheEditJson = JSON.parse(JSON.stringify(preVal));
          return true;
        }
        return false;
      },
      save() {
        if (this.unHandleList.length) {
          this.$ajax.post(this.$api.manage.declare.createAll, this.unHandleList).then(() => {
            this.$message.success("保存成功");
          });
        } else {
          this.$ajax.post(this.$api.manage.declare.createAll, this.tableData).then(() => {
            this.$message.success("保存成功");
          });
        }
      },
      commitTip() {
        this.$nextTick(async () => {
          const $table = this.currentTab === 0 ? this.$refs.unHandle : this.$refs.queryDeclareResult;
          const errMap = await $table.validate(true).catch(errMap => errMap)
          if (!errMap) {
            this.showCommitTip = true;
            // this.$ajax.get(this.$api.manage.declare.commitOecTip,{WkNoPram:WkNo},{noLoading:true}).then((res) => {
            // res.message? this.needConfirmed=true: this.needConfirmed=false;
            // this.message=res.message;
            // }).finally(()=>{
            //   this.showCommitTip=true;
            // });
          }
        })
      },
      submit() {
        const WkNo = this.currentTab === 0 ? this.currWkNo : this.authWkNo;
        this.$ajax.get(this.$api.manage.declare.submit, {WkNo: WkNo}).then(() => {
          this.getList().then(() => {
            this.getCurrRateSum().then(res => {
              this.rateSum = res;
            });
            this.getCurrRateSum(this.month).then(res => {
              this.currentSum = res;
            });
          });
          this.$message.success("提交成功");
        }).finally(() => {
          this.showCommitTip = false;
        });
      },
      revert() {
        this.showRevert = false;
        this.$ajax.put(this.$api.manage.declare.revert, {sendNo: this.currWkNo}).then(() => {
          this.getList();
          this.$message.success("撤回成功");
        });
      },
      pageChange({currentPage}) {
        this.page.PageIndex = currentPage;
        this.getList();
      },
      historyPageChange({currentPage}) {
        this.historyPage.PageIndex = currentPage;
        this.getHistoryList();
      },
      async getAnalyzeNum(param) {
        return new Promise(resolve => {
          this.$ajax.get(this.$api.manage.declare.analyzeNum, param, {noLoading: true}).then((res) => {
            res.data ? resolve(res.data) : resolve({});
          });
        });
      },
      getCurrRateSum(month) {
        return new Promise(resolve => {
          this.$ajax.get(this.$api.manage.declare.rateSum, {wkNo: this.currWkNo, isSub: true, Month: month}, {noLoading: true}).then((res) => {
            res.data ? resolve(res.data) : resolve({});
          });
        });
      },
      async getOecStatus() {
        await this.$ajax.get(this.$api.common.getDict, {ItemType: 'OecStatus'}).then((res) => {
          this.OecStatusList = res.data.rows || res.data || [];
        });
      },
      // eslint-disable-next-line no-unused-vars
      expandRow({row, triggerTreeNode}) {
        if (triggerTreeNode) return;
        row.expandRowFlag = !row.expandRowFlag;
        this.$refs.unHandle.updateData(this.tableData);
      },
      // eslint-disable-next-line no-unused-vars
      historyExpandRow({row, rowIndex}) {
        row.expandRowFlag = !row.expandRowFlag;
        this.$refs.handled.updateData(this.historyData);
      },
      async getDep() {
        await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
          this.depList = res.data || [];
          const obj = {};
          this.depList.forEach(v => {
            const objClone = _.cloneDeep(obj);
            objClone.id = v.id,
                objClone.code = v.code,
                objClone.label = v.displayName
            if (v.parentId === null) {
              this.expandedData.push(v.id);
              objClone.children = this.depList.filter(t => t.parentId === v.id);
              this.generateMenu(objClone.children);
              this.treeData.push(objClone);
              this.copyTreeData = _.cloneDeep(this.treeData);
              this.historyTreeData.push(objClone);
              this.historyCopyTreeData = _.cloneDeep(this.historyTreeData);
            }
          });
        });
      },
      generateMenu(chs) {
        chs.forEach(v => {
          v.label = v.displayName
          v.children = this.depList.filter(t => t.parentId === v.id)
          this.generateMenu(v.children);
        });
      },
      handleCheckChange(data, checked) {
        if (checked === true) {
          this.checkId = data.id;
          this.departmentNo = data.code;
          this.department = data.label;
          this.$refs.tree.setCheckedKeys([data.id]);
        } else {
          if (this.checkId === data.id) {
            this.checkId = '';
            this.departmentNo = '';
            this.department = '';
            this.$refs.tree.setCheckedKeys([]);
          }
        }
      },
      historyHandleCheckChange(data, checked) {
        if (checked === true) {
          this.historyCheckId = data.id;
          this.historyDepartmentNo = data.code;
          this.historyDepartment = data.label
          this.$refs.historyTree.setCheckedKeys([data.id]);
        } else {
          if (this.historyCheckId === data.id) {
            this.historyCheckId = "";
            this.historyDepartmentNo = "";
            this.historyDepartment = "";
            this.$refs.historyTree.setCheckedKeys([]);
          }
        }
      },
      getChildrenMenu(depData) {
        let depTree = [];
        depData.forEach(t => {
          if (t.label.indexOf(this.department) != -1) {
            depTree.push(t)
          } else {
            if (t.children && t.children && t.children.length) {
              t.children = this.getChildrenMenu(t.children)
              if (t.children && t.children.length) {
                depTree.push(t)
              }
            }
          }
        });
        return this.treeData = depTree;
      },
      filterHistoryDeptNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      foldHistoryTree() {
        let treeList = this.historyTreeData;
        //关键代码
          for (let i = 0; i < treeList.length; i++) {
            this.$refs.historyTree.store.nodesMap[treeList[i].id].expanded = false;
          }
      },
      getHistoryChildrenMenu(depData) {
        let depTree = [];
        depData.forEach(t => {
          if (t.label.indexOf(this.historyDepartment) != -1) {
            depTree.push(t)
          } else {
            if (t.children && t.children && t.children.length) {
              t.children = this.getHistoryChildrenMenu(t.children)
              if (t.children && t.children.length) {
                depTree.push(t)
              }
            }
          }
        });
        return this.historyTreeData = depTree;
      },
      handledHide() {
        this.$nextTick(() => {
          if (!this.$refs.tree.getCheckedKeys().length) {
            this.department = "";
          }
        });
      },
      historyHandledHide() {
        this.$nextTick(() => {
          if (!this.$refs.historyTree.getCheckedKeys().length) {
            this.historyDepartment = "";
          }
        });
      },
      async getPersonnelAuthorization(wkNo) {
        await this.$ajax.get(this.$api.manage.declare.getPersonnelAuthorization + "?AuthorizedPersonNo=" + wkNo).then(res => {
          res.data && this.tabList.push({label: '授权申报' + '~' + res.data.authorizerName + '(' + res.data.authorizerNo + ')', id: 1});
          res.data && (this.authWkNo = res.data.authorizerNo);
        });
      },
      approve(action) {
        let param = {
          wkNo: this.wkNo,
          MsgId: this.msgId,
          Remark: this.approveReason
        };
        if (action === "access") {
          param.status = 10;
          this.showAccess = false;
        } else {
          param.status = 0;
          if (!this.approveReason) {
            this.$message.error("必须填写驳回原因！");
            return false;
          }
          this.showRefuse = false;
        }
        this.$ajax.get(this.$api.manage.declare.updateStatus, param).then(() => {
          this.$message.success("审批成功");
          this.getList();
        });
      },
      closeRefuse() {
        this.approveReason = '';
      },
      closeAccess() {
        this.approveReason = '';
      },

      exportResultExcel() {
        this.declareForm.wkNo = this.currWkNo;
        this.declareForm.Date = this.date;
        this.$ajax.get(this.$api.manage.declare.exportResult, this.declareForm, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = 'OEC结果申报'
            const filetype = 'xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },

      formatRecommendList(list = []) {
        if (!Array.isArray(list)) return '';
        let result = '';
        list.forEach((item, i) => {
          let res = this.importanceList.find(t => t.itemValue == item.importanceLevel);
          result += `${res ? res.itemDesc : ''} ${item.ratingResult} ${item.wkName}(${item.wkNo}) ${this.formatRecommendStatus(item.status)} ${item.ratingReason || ''}`;
          if (i < list.length - 1) {
            result += '\n';
          }
        })
        return result;
      },
      getRecommendStatus() {
        this.$ajax.get(this.$api.common.getDict, {ItemType: 'OECRecommendDeclare'}).then((res) => {
          this.recommendStatusList = res.data.rows || res.data || [];
        });
      },
      formatRecommendStatus(status) {
        const item = this.recommendStatusList.find(t => t.itemValue == status);
        return item ? item.itemDesc : '';
      },

      declareExpandRowAll() {
        if (this.declareExpandRowAllFlag) {
          this.tableData.forEach(val => {
            val.expandRowFlag = false;
          });
        } else {
          this.tableData.forEach(val => {
            val.expandRowFlag = true;
          });
        }
        this.declareExpandRowAllFlag = !this.declareExpandRowAllFlag;
        this.$refs.unHandle.updateData(this.tableData);

        this.$nextTick(() => {
          if (this.$refs.unHandle) {
            let scrollInfo = this.$refs.unHandle.getScroll();
            this.$refs.unHandle.scrollTo(scrollInfo.scrollLeft, scrollInfo.scrollTop + 1);
          }
        });
      },

      historyExpandRowAll() {
        if (this.historyExpandRowAllFlag) {
          this.historyData.forEach(val => {
            val.expandRowFlag = false;
            if (val.children && val.children.length > 0) {
              val.children.forEach(item => {
                item.expandRowFlag = false;
              })
            }
          });
        } else {
          this.historyData.forEach(val => {
            val.expandRowFlag = true;
            if (val.children && val.children.length > 0) {
              val.children.forEach(item => {
                item.expandRowFlag = true;
              })
            }
          });
        }
        this.historyExpandRowAllFlag = !this.historyExpandRowAllFlag;
        this.$refs.handled.updateData(this.historyData);

        this.$nextTick(() => {
          if (this.$refs.handled) {
            let scrollInfo = this.$refs.handled.getScroll();
            this.$refs.handled.scrollTo(scrollInfo.scrollLeft, scrollInfo.scrollTop + 1);
          }
        });
      },
      getImportanceList() {
        this.$ajax.get(this.$api.common.getDict, {ItemType: 'OECRecommendImportance'}).then((res) => {
          this.importanceList = res.data.rows || res.data || [];
        });
      },
    },
    watch: {
      $route(){
        this.reload();
      },
      department: {
        handler(val) {
          const depTree = _.cloneDeep(this.copyTreeData);
          this.getChildrenMenu(depTree);
          if (!val) {
            this.departmentNo = "";
            this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
          }
        },
        immediate: true
      },
      historyDepartment: {
        handler(val) {
          this.$refs.historyTree && this.$refs.historyTree.filter(val);
          if (!val) {
            this.historyDepartmentNo = "";
            if (this.$refs.historyTree) {
              // this.foldHistoryTree(val);
              setTimeout(() => {
                const depTree = _.cloneDeep(this.historyCopyTreeData);
                this.historyTreeData = depTree;
              }, 10)
              this.$refs.historyTree.setCheckedKeys([]);
            }
          }
        },
        immediate: true
      },

    }
  }
</script>
<style scoped lang='scss'>
  .notice {
    .atb-ellipsis-line-2 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .pre-line {
      white-space: pre-line;
    }
    .search-wrap {
      .atb-input {
        display: flex;
        .form-param-item {
          width: 20%;
          ::v-deep .el-form-item__content {
            width: calc(100% - 50px);
            .customerSelect {
              width: 100%;
            }
          }
        }
      }
    }
    .table-wrap {
      margin-top: 20px;
      .el-pagination {
        text-align: right;
        margin-top: 20px;
      }
    }
    .search-wrap {
      .atb-input {
        display: flex;
        .form-param-item {
          width: 20%;
          ::v-deep .el-form-item__content {
            width: calc(100% - 50px);
            .customerSelect {
              width: 100%;
            }
          }
        }
      }
    }
    .search {
      .atb-input {
        display: flex;
        flex-direction: column;
        .query-where {
          display: flex;
          .flex-form-item {
            display: flex;
            flex: 1;
            margin-bottom: 12px;
          }
          ::v-deep.el-form-item__content {
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor {
              width: 100%;
            }
          }
        }
        .query-operation {
          display: flex;
        }
      }
    }
    height: 100%;
    .atb-content-bg {
      margin-top: 15px;
      padding: 20px;
      flex: 1;
    }
    ::v-deep .tab {
      margin-top: -3px;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    .summary {
      margin-bottom: 12px;
      font-size: 14px;
      color: #4a5150;
      .item-data {
        margin-right: 40px;
        .cursor{
          cursor: pointer;
        }
        .num {
          font-weight: bolder;
          color: #22b6a1;
          padding: 10px;
        }
        .warn-num {
          font-weight: bolder;
          color: #fe6562;
          padding: 10px;
        }
      }
    }
  }
</style>
<style>
  .declare-dep {
    height: 350px;
    width: 350px;
    overflow: auto;
  }
</style>